export type CartVariant = 'classic' | 'modern'

/** Missing or unknown template settings retain the established cart. */
export const resolveCartVariant = (value: unknown): CartVariant => (
  value === 'modern' ? 'modern' : 'classic'
)
